/**
 * ドライバー情報
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/drivers`

const search_driver = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    index (context, params) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params }).then(data => {
          resolve(data.content)
        })
      })
    },
    only_text (context, params) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params }).then(data => {
          const content = data.content
          let drivers = []
          for (const driver of content.drivers) {
            drivers.push(driver.text)
          }
          resolve(drivers)
        })
      })
    },
  },
  mutations: {},
}
export default search_driver
